import { MoreVertical, Trash } from "lucide-react"
import { useTranslation } from "react-i18next"

import {
  Button,
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@f2e/ui/components/base"

export interface ConnectionActionButtonProps {
  className?: string
  onDelete?: (event: React.MouseEvent) => void
}

const ConnectionActionButton = ({
  className,
  onDelete,
}: ConnectionActionButtonProps) => {
  const { t } = useTranslation()

  return (
    <div className={className}>
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button
            variant="ghost"
            size="icon"
            className="focus-visible:ring-0 focus-visible:ring-offset-0"
          >
            <MoreVertical className="w-4 h-4" />
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent onClick={(e) => e.stopPropagation()}>
          {onDelete && (
            <DropdownMenuItem
              className="text-red-500"
              onClick={(e) => {
                onDelete(e)
              }}
            >
              <Trash className="w-4 h-4 mr-2" />
              {t("connection.common.actions.delete")}
            </DropdownMenuItem>
          )}
        </DropdownMenuContent>
      </DropdownMenu>
    </div>
  )
}

export { ConnectionActionButton }
export default ConnectionActionButton
